import { DealerLoginComponent } from './dealer-login/dealer-login.component';
import { PreferencesComponent } from './dashboard/preferences/preferences.component';
import { PaymentsComponent } from './dashboard/payments/payments.component';
import { Faq2Component } from './dashboard/faq2/faq2.component';
import { ListStoresComponent } from './dashboard/list-stores/list-stores.component';
import { OverviewComponent } from './dashboard/overview/overview.component';
import { BillingComponent } from './dashboard/billing/billing.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BillingHistoryComponent } from './billing-history/billing-history.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { FaqComponent } from './faq/faq.component';
import { PricingPlanComponent } from './pricing-plan/pricing-plan.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StoreEditorComponent } from './dashboard/store-editor/store-editor.component';
import { DomainListComponent } from './dashboard/domain-list/domain-list.component';
import { DomainFormComponent } from './dashboard/domain-form/domain-form.component';
import { CustomersCartsComponent } from './dashboard/customers-carts/customers-carts.component';
import { ReplayComponent } from './dashboard/replay/replay.component';
import { HeatmapComponent } from './dashboard/heatmap/heatmap.component';
import { HeatmapViewComponent } from './dashboard/heatmap-view/heatmap-view.component';
import { VisitorIntelligenceComponent } from './dashboard/visitor-intelligence/visitor-intelligence.component';
import { RevenueLostReportComponent } from './dashboard/revenue-lost-report/revenue-lost-report.component';
import { LandingPageReportComponent } from './dashboard/landing-page-report/landing-page-report.component';
import { ReplaySessionsComponent } from './dashboard/replay-sessions/replay-sessions.component';
import { ReplayPlayerComponent } from './dashboard/replay-player/replay-player.component';
import { OrdersComponent } from './dashboard/orders/orders.component';
import { OrdersTabsComponent } from './dashboard/orders-tabs/orders-tabs.component';
import { CreateStoreComponent } from './create-store/create-store.component';
import { AccessDeniedComponent } from './sso/access-denied.component';
import { CanDeactivateGuard, RouteGuard } from './route.guard';
import { SSOComponent } from './sso/sso.component';
import { PaymentFailedComponent } from './sso/payment-failed.component';
import { ProductManagerComponent } from './dashboard/product-manager/product-manager.component';
import { ETicketingComponent } from './dashboard/e-ticketing/e-ticketing.component';
import { ETicketingFormComponent } from './dashboard/e-ticketing-form/e-ticketing-form.component';
import { ETicketingListComponent } from './dashboard/e-ticketing-list/e-ticketing-list.component';
import { ETicketingInfoComponent } from './dashboard/e-ticketing-info/e-ticketing-info.component';
import { ProductManagerFormComponent } from './dashboard/product-manager-form/product-manager-form.component';
import { GalleryComponent } from './dashboard/gallery/gallery.component';
import { CreateMediaComponent } from './dashboard/create-media/create-media.component';
import { DiscountsComponent } from './dashboard/discounts/discounts.component';
import { AddDiscountComponent } from './dashboard/add-discount/add-discount.component';
import { ContentEditorComponent } from './dashboard/content-editor/content-editor.component';
import { EmailTemplateComponent } from './dashboard/email-template/email-template.component';
import { EditTemplateComponent } from './dashboard/edit-template/edit-template.component';
import { EmailSettingComponent } from './dashboard/email-setting/email-setting.component';
import { KnowledgeBaseComponent } from './dashboard/knowledge-base/knowledge-basecomponent';
import { ThemeListComponent } from './dashboard/theme-list/theme-list.component';
import { ThemeSelectPageComponent } from './dashboard/theme-select-page/theme-select-page.component';
import { NotificationComponent } from './dashboard/notification/notification.component';
import { ProductEditComponent } from './dashboard/product-edit/product-edit.component';
import { PageManageComponent } from './dashboard/page-manage/page-manage.component';
import { OrdersCodComponent } from './dashboard/orders-cod/orders-cod.component';
import { DetailKnowledgeComponent } from './dashboard/detail-knowledge/detail-knowledge.component';
import { ExpressCheckoutComponent } from './dashboard/express-checkout/express-checkout.component';
import { ExpressCheckoutCreateComponent } from './dashboard/express-checkout-create/express-checkout-create.component';
import { MenuManagerComponent } from './dashboard/menu-manager/menu-manager/menu-manager.component';
import { PagesComponent } from './dashboard/pages/pages.component';
import { DesignComponent } from './dashboard/design/design.component';
import { ExpressCheckoutDashboardComponent } from './dashboard/express-checkout-dashboard/express-checkout-dashboard.component';
import { ReferralComponent } from './dashboard/referral/referral.component';
import { LoginComponent } from './login/login.component';
import { ProductFaqComponent } from './dashboard/product-faq/product-faq.component';
import { ProductFaqCreateComponent } from './dashboard/product-faq-create/product-faq-create.component';
import { ProductFaqEditComponent } from './dashboard/product-faq-edit/product-faq-edit.component';
import { ProductFaqExistGuard } from './guard/product-faq-exist.guard';
import { FacebookApiComponent } from './dashboard/facebook-api/facebook-api.component';
import { ReferralStatusGuard } from './guard/referral_status.guard';
import { OrderSubscriptionComponent } from './dashboard/order-subscription/order-subscription.component';
import { OrderSubscriptionDetailComponent } from './dashboard/order-subscription-detail/order-subscription-detail.component';
import { AiLandingPageCompareComponent } from './dashboard/ai-landing-page-compare/ai-landing-page-compare.component';
import { AiLandingPageComponent } from './dashboard/ai-landing-page/ai-landing-page.component';
// TEST
const routes: Routes = [
  {
    path: 'sso/login',
    canActivate: [RouteGuard],
    component: SSOComponent,
  },
  {
    path: 'homepage',
    canActivate: [RouteGuard],
    component: LandingPageComponent,
    data: { navbar: 'true', footer: 'true' },
  },
  {
    path: 'pricing-plan',
    component: PricingPlanComponent,
    data: { navbar: 'true', footer: 'true' },
  },
  {
    path: 'billing-history',
    component: BillingHistoryComponent,
    data: { navbar: 'true', footer: 'true' },
  },
  {
    path: 'create-store',
    canActivate: [RouteGuard],
    component: SignUpComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivateChild: [RouteGuard],
    children: [
      {
        path: 'overview',
        component: OverviewComponent,
      },
      {
        path: 'billing',
        component: BillingComponent,
      },
      {
        path: 'list-stores',
        component: ListStoresComponent,
      },
      {
        path: 'faq',
        component: Faq2Component,
      },
      {
        path: 'payments',
        component: PaymentsComponent,
      },
      {
        path: 'preferences',
        component: PreferencesComponent,
      },
      {
        path: 'setting',
        redirectTo: 'preferences',
        pathMatch: 'full',
      },
      { path: 'design', component: DesignComponent },
      {
        path: 'store-editor',
        component: StoreEditorComponent,
      },
      {
        path: 'themes',
        component: ThemeListComponent,
      },
      {
        path: 'theme-select-page',
        component: ThemeSelectPageComponent,
      },
      {
        path: 'content-editor',
        component: ContentEditorComponent,
      },
      {
        path: 'abandoned-carts',
        component: CustomersCartsComponent,
      },
      {
        path: 'domain',
        component: DomainListComponent,
      },
      {
        path: 'domain-form',
        component: DomainFormComponent,
      },
      {
        path: 'customers',
        component: CustomersCartsComponent,
      },
      {
        path: 'visitor-intelligence',
        component: VisitorIntelligenceComponent,
      },
      {
        path: 'revenue-lost-report',
        component: RevenueLostReportComponent,
      },
      {
        path: 'landing-page-report',
        component: LandingPageReportComponent,
      },
      {
        path: 'replay',
        component: ReplayComponent,
      },
      {
        path: 'replay/heatmap',
        component: HeatmapComponent,
      },
      {
        path: 'replay/heatmap/:sessionId',
        component: HeatmapViewComponent,
      },
      {
        path: 'replay/:visitorId',
        component: ReplaySessionsComponent,
      },
      {
        path: 'replay/:visitorId/:sessionId',
        component: ReplayPlayerComponent,
      },
      {
        path: 'orders',
        component: OrdersTabsComponent,
      },
      {
        path: 'orders/:id',
        component: OrdersTabsComponent,
      },
      {
        path: 'orders-cod',
        component: OrdersCodComponent,
      },
      {
        path: 'product-manager',
        component: ProductManagerComponent,
      },
      {
        path: 'product-faq',
        component: ProductFaqComponent,
        canActivate: [ProductFaqExistGuard],
      },
      {
        path: 'product-faq/create',
        component: ProductFaqCreateComponent,
      },
      {
        path: 'product-faq/edit/:id',
        component: ProductFaqEditComponent,
      },
      {
        path: 'product-manager-form',
        component: ProductManagerFormComponent,
      },
      {
        path: 'product/edit/:langCode/:countryCode/:id',
        component: ProductEditComponent,
      },
      // {
      //   path: 'product/edit/:id/:langCode',
      //   component: ProductEditComponent,
      // },
      {
        path: 'product/edit/:id',
        component: ProductEditComponent,
      },
      {
        path: 'page/edit/:id',
        component: PageManageComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'page/create',
        component: PageManageComponent,

        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'e-ticketing',
        component: ETicketingComponent,
      },
      {
        path: 'e-ticketing-form',
        component: ETicketingFormComponent,
      },
      {
        path: 'e-ticketing-list',
        component: ETicketingListComponent,
      },
      {
        path: 'e-ticketing-info/:id',
        component: ETicketingInfoComponent,
      },
      {
        path: 'gallery',
        component: GalleryComponent,
      },
      {
        path: 'create-media',
        component: CreateMediaComponent,
      },
      // {
      //   path: 'discounts',
      //   component: DiscountsComponent,
      // },
      // {
      //   path: 'add-discount',
      //   component: AddDiscountComponent,
      // },
      {
        path: 'email-template',
        component: EmailTemplateComponent,
      },
      {
        path: 'edit-template/:id',
        component: EditTemplateComponent,
      },
      {
        path: 'email-setting',
        component: EmailSettingComponent,
      },
      {
        path: 'knowledge-base',
        component: KnowledgeBaseComponent,
      },
      {
        path: 'detail-knowledge-base',
        component: DetailKnowledgeComponent,
      },
      {
        path: 'notification',
        component: NotificationComponent,
      },
      {
        path: 'express-checkout',
        component: ExpressCheckoutComponent,
      },
      {
        path: 'express-checkout-create',
        component: ExpressCheckoutCreateComponent,
      },
      {
        path: 'express-checkout/edit/:country_code/:slug',
        component: ExpressCheckoutCreateComponent,
      },
      {
        path: 'menu-manager',
        component: MenuManagerComponent,
      },
      {
        path: 'pages',
        component: PagesComponent,
      },
      {
        path: 'express-checkout-dashboard',
        component: ExpressCheckoutDashboardComponent,
      },
      {
        path: 'referral',
        canActivate: [ReferralStatusGuard],
        component: ReferralComponent,
      },
      {
        path: 'fb-api',
        component: FacebookApiComponent,
      },
      { path: 'order-subscription', component: OrdersTabsComponent },
      {
        path: 'order-subscription/detail/:id/:storeId',
        component: OrderSubscriptionDetailComponent,
      },
      {
        path: 'ai-landing-page',
        component: AiLandingPageComponent,
      },
      {
        path: 'ai-landing-page-compare',
        component: AiLandingPageCompareComponent,
      }
    ],
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: { navbar: 'true', footer: 'true' },
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
  },
  {
    path: 'dealer-login',
    component: DealerLoginComponent,
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'payment-failed',
    component: PaymentFailedComponent,
  },
  {
    path: '**',
    component: AccessDeniedComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
